// Initialize DataDog RUM Monitoring
import 'lib/browserMonitoring/initialize'

// For now we are using the same styles as StorePage
import './shoplist-app/store/bundle.scss'
import 'marketing-components/dist/components/organisms/footer/less/footer.less'
import { initA11yLinting } from 'lib/initA11yLinting'

// @ts-ignore
__webpack_public_path__ = window.webpackPublicPath

// The TMPlusStorePage uses SSR, we render that separately from the rest of the app.
// Even the styles are loaded separately.

window.addEventListener('DOMContentLoaded', () => {
  require('./render-tmplus-store')
})

initA11yLinting()
